'use client';
import { useEffect, useState } from 'react';
import { FE_ONLY } from './flags';
import { authHeaders } from './auth';

export function useHealth(endpoint: string) {
  const [state, setState] = useState<'up' | 'down' | 'unknown'>('unknown');
  useEffect(() => {
    if (FE_ONLY) { setState('unknown'); return; }
    const ctrl = new AbortController();
    fetch(endpoint, { signal: ctrl.signal, headers: authHeaders() })
      .then(r => setState(r.ok ? 'up' : 'down'))
      .catch(() => setState('down'));
    return () => ctrl.abort();
  }, [endpoint]);
  return state;
}
